<template>
  <div v-show="Object.keys(testContent).length > 0" class="evaluation-wrapper">
    <div class="wrapper-main">
      <!-- 轮播图和商品信息 -->
      <goodsInfo :goodsParams="goodsImgs" :swiperArr="swiperArr" :point="true" :state="true" @goBack="goBack" from='evaluationDetail' btnStyle="width:100%;height:100px;"></goodsInfo>
      <!-- 商品评价 -->
      <div class="shop-evaluate">
        <div v-if="testContent.aspectScoreList && !testContent.aspectScoreList.length"  class="evaluation-shop-evaluate">
          <div class="evaluation-evaluate-title">商品评价：</div>
          <van-rate
            v-model="value"
            :icon="scoreStar"
            :void-icon="scoreStarActive"
            allow-half
            :readonly = "true"
          />
        </div>

        <div v-if="testContent.aspectScoreList && testContent.aspectScoreList.length"  class="evaluation-Score">
          <ul>
            <li v-for="(item, index) in resultList" :key="index">
              <div class="title">{{ item.aspectDesc + ':' }}</div>
              <div class="score">
                <van-rate
                  v-model="item.aspectScore"
                  :icon="scoreStar"
                  :void-icon="scoreStarActive"
                  allow-half
                  :readonly = "true"
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 测评内容 -->
      <div class="user-testinfo-item-wrapper">
        <div class="testuser-info row">
          <img :src="testContent.userUrl" alt="" width="50px" height="50px" style="border-radius: 50%;">
          <div style="margin-left: 6px;">
            <div class="test-message-roles">{{ testContent.userName }}</div>
            <img :src="userLevelImg" alt="" width="54px" height="14px">
          </div>
        </div>
        <div class="testgoods-title">{{ testContent.title }}</div>
        <div class="testgoods-status">
          <img
            alt=""
            class="look-people-number"
            src="@/assets/images/trialProductsList/look.png"
          />
          <div class="numbers-text">{{ fomatterNum(testContent.lookNum) }}</div>
        </div>
        <div v-for="(item, index) in commentContentArr" :key="index" class="testgoods-content">
            {{ item }}
          </div>
      </div>
    </div>
    <div class="wrapper-btn">
      <div class="apply-btn">
        <div>
            <img :src="type ? activedLike : defaultLike" alt="" class="like-people-number" @click="addLike(type, 0)">
            <p class="icon-text">{{ testContent.likeNum === 0 ? '有帮助' : fomatterNum(testContent.likeNum) }}</p>
          </div>
          <div btn-icon>
            <img :src="typeNo ? activedHelp : defaultHelp" alt="" class="like-people-number" @click="addLike(typeNo , 1)">
            <p class="icon-text">{{ !testContent.notLikeNum ||testContent.notLikeNum === 0 ? '没帮助' : fomatterNum(testContent.notLikeNum) }}</p>
          </div>
        <button @click="shareGoods">转发给朋友</button>
      </div>
      <audioShare ref="share"></audioShare>
    </div>
  </div>
</template>

<script>
import {
  Debounce,
  fomatterNum,
  getCookie,
  getUserInfo,
  isUserLogin,
} from '@/assets/js/common.js'
import goodsInfo from '@/components/contents/trialProductsList/goodsInfo.vue'
import {BuiedPointClick_Fn} from "@assets/js/BuriedPointEvent";
import audioShare from '@/components/comment/share.vue'
import API from '@/utils/axiosApi/zeroShoppingApi.js'
import { freetrialClick, freetrialView } from '@/utils/freetrialClick.js'
import { log } from 'console';

export default {
  components: { goodsInfo, audioShare },
  data() {
    return {
      goodData: {},
      goodsImgs: {}, //测评商品信息
      swiperArr: [], //轮播数组
      testContent: {}, //测评内容
      defaultLike: require('@/assets/images/trialProductsList/helpfulness.png'),
      activedLike: require('@/assets/images/trialProductsList/helpfulness-new.png'),
      defaultHelp: require('@/assets/images/trialProductsList/no-help.png'),
      activedHelp: require('@/assets/images/trialProductsList/no-help-new.png'),
      v1: require('@/assets/images/trialProductsList/v1-member.png'),
      v2: require('@/assets/images/trialProductsList/v2-member.png'),
      v3: require('@/assets/images/trialProductsList/v3-member.png'),
      v4: require('@/assets/images/trialProductsList/v4-member.png'),
      v5: require('@/assets/images/trialProductsList/v5-member.png'),
      type: false, //false有帮助状态  true有帮助高亮状态
      typeNo: false, //false没帮助状态  true没帮助高亮状态
      userLevelImg: '',
      testId: '', //测评id
      value: 0, // 商品评价
      commentContentArr: [], // 测评多行数据
      resultList: [
        { aspectDesc: "商品评价", aspectScore: 4 },
        { aspectDesc: "后台评价", aspectScore: 4 },
        { aspectDesc: "后台评价", aspectScore: 3 },
        { aspectDesc: "后台评1", aspectScore: 3 },
        { aspectDesc: "评2", aspectScore: 5 },
        { aspectDesc: "后台评3", aspectScore: 2 },
      ],
      scoreStarActive: require("@/assets/images/trialProductsList/star@2x.png"), // 评分星星active
      scoreStar: require("@/assets/images/trialProductsList/star-active@2x.png"), // 评分星星
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goBack: Debounce(function () {
      if (window.history.length > 1 && getCookie('fromPath')) {
        this.$router.back(-1)
      } else {
        this.$router.replace('/trialProducts')
      }
    }),
    fomatterNum,
    getTestGoodsDetail(id) {
      const params = {
        id,
        crmId: getUserInfo(),
      }
      API.getTestDetail({}, params, (res) => {
        if (res.code === 200 && res.data != null) {
          console.log(3333, res.data)
          const {
            commentUrlList,
            productId,
            skuId,
            goodsUrl,
            goodsName,
            userUrl,
            userName,
            commentContent,
            lookNum,
            likeNum,
            notLikeNum,
            id,
            needLike,
            needNoLike,
            aspectScoreList,
            goodsScore,
            userLevel
          } = res.data
          this.swiperArr = commentUrlList
          this.testId = id
          this.value = goodsScore || 5
          // 会员等级标识匹配
          if(userLevel.indexOf("铂金") != -1){
            this.userLevelImg = this.v2
          }else if(userLevel.indexOf("钻石") != -1){
            this.userLevelImg = this.v3
          }else if(userLevel.indexOf("星光") != -1){
            this.userLevelImg = this.v4
          }else if(userLevel.indexOf("星耀") != -1){
            this.userLevelImg = this.v5
          }else{
            this.userLevelImg = this.v1
          }
          this.type = needLike //有帮助状态
          this.typeNo = needNoLike //没帮助状态
          let arr = JSON.parse(JSON.stringify(aspectScoreList))
          arr.unshift({ aspectDesc: "商品评价", aspectScore: this.value },)
          this.resultList = arr
          // console.log(this.resultList, '评分',aspectScoreList)
          this.goodsImgs = {
            img: goodsUrl,
            title: goodsName.length > 20 ? goodsName.slice(0, 21) : goodsName,
            productId: productId,
            skuId: skuId,
            id: id,
          }

          this.testContent = {
            userUrl,
            userName,
            goodsName,
            commentContent,
            lookNum,
            likeNum,
            notLikeNum,
            aspectScoreList
          }
          this.testContent.title = this.testContent.commentContent.slice(0, 20)
          this.commentContentArr = this.testContent.commentContent.split('\n')
          // 浏览曝光商品名称埋点
          BuiedPointClick_Fn("xmhh5_freetrial_product_expo", {
            xmhh5_freetrial_detailitem_expo:goodsName
          });
          // 分享
          this.sharePage(goodsName, commentUrlList[0])
          console.log(3334, this.goodsImgs)
          // this.goodData = res.data
        } else {
          if (res.code == 1000) {
            this.$toast({
              message: '测评已不存在',
              duration: 2000,
            })
            setTimeout(() => {
              this.$router.push('/trialProducts')
            }, 1000)
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
            })
          }
        }
      })
    },
    shareGoods() {
      freetrialClick({ xmhh5_Freetrial_pageclick: '测评详情-转发给朋友' })
      this.$refs.share.showShareVideo()
    },
    sharePage(shareTitle, img) {
      const shareDataParams = {
        shareLink: location.href.split('#')[0],
        shareDesc: '星妈会限时0元试用活动，中奖率超高，快来参加免费领取吧~',
        shareTitle,
        imgUrl: img || 'https://image-mom.feihe.com/wxshare/home.png',
        // imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
      }
      this.wxJsSet.wxShare('fx', shareDataParams, this)
    },
    // 点赞
    addLike: Debounce(function (type, module) {

      const params = {
        id: this.testId,
        crmId: getUserInfo(),
        type: type ? 1 : 0,
        module
      }
      // console.log(type, module , '接口入参', params)
      API.addLike({}, params, (res) => {
        if (res.code == 200 && res.data == true) {
          if(module === 0) this.type = !this.type
          if(module === 1) this.typeNo = !this.typeNo
          if(module === 0) {
            if (this.type) {
              this.testContent.likeNum = this.testContent.likeNum + 1
            } else {
              this.testContent.likeNum = this.testContent.likeNum - 1
            }
            freetrialClick({ xmhh5_Freetrial_pageclick: '有帮助' })
          }
          if(module === 1) {
            if (this.typeNo) {
            this.testContent.notLikeNum = this.testContent.notLikeNum + 1
            } else {
              this.testContent.notLikeNum = this.testContent.notLikeNum - 1
            }
            freetrialClick({ xmhh5_Freetrial_pageclick: '没帮助' })
          }
        } else {
          this.$toast({
            message: res.message,
            duration: 2000,
          })
        }
      })
    }),
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (!isUserLogin()) {
      const id = this.$route.params.id
      freetrialView({ xmhh5_Freetrial_pageview: '测评详情' })
      this.getTestGoodsDetail(id)
    } else {
      this.$router.push('/home')
    }
  },
}
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类

.user-testinfo-item-wrapper {
  width: 335px;
  padding: 15px 4px 13px 12px;
  margin: 8px 12px 38px;
  background-color: #fff;
  border-radius: 8px;
}

.testuser-info {
  display: flex;
}

.test-message-roles {
  padding-top: 13px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}

.testgoods-title {
  width: 333px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  margin: 8px 0px 0px;
  line-height: 22px;
}

.testgoods-content {
  width: 336px;
  font-size: 14px;
  font-family: PingFang-SC-Medium, PingFang-SC;
  font-weight: 500;
  color: #666666;
  line-height: 22px;
  letter-spacing: 1px;
}

.testgoods-status {
  display: flex;
  align-items: center;
  margin: 2px 0;
}

.look-people-number {
  width: 18px;
  height: 19px;
  margin-right: 2px;
}

.like-people-number {
  width: 23.5px;
  height: 20.5px;
  margin: 8px 0px 0px 10px;
}

.numbers-text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-left: 5px;
}

.apply-btn {
  width: 375px;
  height: 65px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .icon-text{
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #999999;
      line-height: 20px;
      display: block;
      width: 44px;
      text-align: center;
    }

  button {
    width: 184px;
    height: 45px;
    background: #fc656f;
    border-radius: 25px;
    border-style: none;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

.evaluation-wrapper {
  background: #f8f8f8;
  height: 100vh;
  overflow: auto;
  display: flex;
  flex-direction: column;

  .shop-evaluate{
    width: 351px;
    // height: 103px;
    margin: 12px;
    background: #FFFFFF;
    border-radius: 8px;

    .evaluation-shop-evaluate {
      display: flex;
      align-items: center;
      width: 351px;
      height: 52px;
      .evaluation-evaluate-title {
        height: 23px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 23px;
        margin: 12px 0px 12px 17px;
      }
      /deep/.van-rate {
        .van-rate__item:not(:last-child) {
          padding-right: 8px;
        }
        .van-rate__icon--full {
          width: 21px;
          height: 21px;
          background: linear-gradient(180deg, #fc616b 0%, #fb9095 100%);
          -webkit-background-clip: text;
          color: transparent;
        }
        .van-rate__icon {
          // color: #999;
        }
      }
    }

    .evaluation-Score {
      padding: 12px 0;
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 0 7px;
        li {
          display: flex;
          text-align: left;
          margin-top: 8px;
          min-height: 20px;
          .title {
            width: 65px;
            text-align: right;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            margin-top: -2px;
          }
          .score {
            flex: 1;
            margin-left: 5px;
            /deep/.van-rate {
              .van-rate__item {
                .van-rate__icon {
                  font-size: 16px;
                }
              }
            }
          }
        }
      }
    }
  }

  .wrapper-main {
    flex: 1;
    flex-shrink: 0;
    flex-basis: 0;
    /deep/.tagWrap{
      height: 100px;
    }
  }

  .wrapper-btn {
  }
}
</style>
